import React from 'react';
import { InboundDataType } from '../../../../../context/InboundContext';
import styles from './MultipleOptionsQuestion.module.css';
import { RadioButton } from '../../../../common';

type Props = {
  question: InboundDataType['formSetupPage']['ambassadorProgramQuestions'][number];
  setValue: (v: string) => void;
  value: string;
};

const getSelectedCheckboxOptions = (answer: string): string[] => {
  try {
    const answersArr = JSON.parse(answer);

    if (!Array.isArray(answersArr) || typeof answersArr[0] !== 'string') {
      throw Error();
    }

    return answersArr;
  } catch (error) {
    return [];
  }
};

export default function MultipleOptionsQuestion({ question, setValue, value }: Props) {
  const options = question?.options || [];

  const selectedCheckboxOptions = getSelectedCheckboxOptions(value);

  return (
    <div className={styles?.questionContainer}>
      <div className={styles.question}>
        {question?.question} {question?.isRequired ? '*' : ''}
      </div>

      {question.questionType === 'radio' ? (
        <div className={styles.optionsContainer}>
          {options?.map((option) => (
            <div key={option?._id}>
              <RadioButton
                checked={value === option.name}
                onChange={() => {
                  setValue(option.name);
                }}
                text={option?.name}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.optionsContainer}>
          {options?.map((option) => (
            <div key={option?._id}>
              <label htmlFor={option?._id}>
                <input
                  id={option?._id}
                  className={styles.checkboxInput}
                  checked={selectedCheckboxOptions?.includes(option?.name)}
                  onChange={(e) => {
                    let newOptions = [...selectedCheckboxOptions];

                    if (e.target.checked) {
                      newOptions = Array.from(new Set([...newOptions, option.name]));
                    } else {
                      newOptions = newOptions.filter((o) => o !== option.name);
                    }

                    setValue(JSON.stringify(newOptions));
                  }}
                  type="checkbox"
                />
                <span>{option?.name}</span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
